import type { AppConfig } from './lib/AppConfig';

const appConfigCallback = (/* deployStage: string, deployInstance: string */): AppConfig => {
  // example of how to use deployStage to differentiate between stage/instance settings
  // const exampleSnsTopicArn = deployStage === 'test' ? 'test:stage:arn' : 'dev:stage:arn';
  return {
    aiTutorApiConsumers: [
      {
        accountId: '315901967864',
        accountName: 'hg-ppi-BAN-LOS-Org-Mgmt-Non-Prod',
      },
    ],
    awsAccount: '047719659887',
    emailServiceApiResourceArns: [
      'arn:aws:execute-api:eu-central-1:047719659887:caxwkk7dra/test/POST/emails',
      'arn:aws:execute-api:eu-central-1:047719659887:caxwkk7dra/test/POST/users/*/emails',
    ],
    vamosVeranstaltungsTopicArn: 'arn:aws:sns:eu-central-1:073157177325:veranstaltungen',
    lamaTopicArn: 'arn:aws:sns:eu-central-1:138763365775:lama-topic-test.fifo',
    luActivityProgressUpdateTopicArn:
      'arn:aws:sns:eu-central-1:806609685130:activity-progress-update-topic-cdk-test',

    fullstory: {
      orgId: 'o-5X8P-eu1',
      enabled: true,
      consentId: 'BkZ_qViOj-7',
    },
    oidcClientId: 'aka-ai-tutor',
    oidcDiscoveryUrl:
      'https://integration.login.haufe-lexware.com/auth/oauth2/.well-known/openid-configuration',
    bumArgonautusSecretArn:
      'arn:aws:secretsmanager:eu-central-1:203276844343:secret:argonautus-047719659887-kWefSJ',
    bumArgonautusSecretKmsKeyArn:
      'arn:aws:kms:eu-central-1:203276844343:key/f99bba26-b54a-4942-bd80-14fcff1df45c',
    bumArgonautusApiResourceArns: [
      'arn:aws:execute-api:eu-central-1:203276844343:pdj57p94bb/argonautus/GET/veranstaltungsbuchungen/v2.0',
    ],
  };
};
export default appConfigCallback;
